import { Component, Inject, Input } from '@angular/core';
import { AppSettings, AssetUIModel, ClientEnvironment, ENVIRONMENT } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';

@Component({
  selector: 'sp-expiry-days-warning',
  templateUrl: './expiry-days-warning.component.html',
  styleUrls: ['./expiry-days-warning.component.scss'],
})
export class ExpiryDaysWarningComponent {
  @Input() asset!: AssetUIModel;
  expiryAssetInDays = AppSettings.SHOW_EXPIRY_ASSET_IN_DAYS;

  CustomClients = CustomClients;
  brandingKey!: CustomClients;

  textExpiredOn = $localize`Asset expired on`;
  textWillExpireOn = $localize`Asset will expire on`;
  constructor(@Inject(ENVIRONMENT) env: ClientEnvironment) {
    this.brandingKey = env.brandingKey ?? CustomClients.Standard;
  }
}
